import { createContext, useState } from "react";

const RoleTabContext = createContext("");
const RoleTabDispatchContext = createContext((value) => {});

const RoleTabProvider = ({ children }) => {
  const [role, setRole] = useState("");

  return (
    <RoleTabContext.Provider value={role}>
      <RoleTabDispatchContext.Provider value={setRole}>
        {children}
      </RoleTabDispatchContext.Provider>
    </RoleTabContext.Provider>
  );
};

export { RoleTabProvider, RoleTabContext, RoleTabDispatchContext };
